import { Box, CircularProgress, Typography } from '@mui/material'

export function LoadingScreen() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
      }}
      role="status"
      aria-label="Laden..."
    >
      <CircularProgress color="primary" size={48} />
      <Typography variant="body2" color="text.secondary">
        Laden...
      </Typography>
    </Box>
  )
}